import isEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';

/**
 * Compares two objects and returns only the fields that have changed.
 * Useful for PATCH requests where only modified fields should be sent.
 */
export function getChangedFields<T extends object>(
  original: T,
  updated: T
): Partial<T> {
  return pickBy(
    updated,
    (value, key) => !isEqual(value, original[key as keyof T])
  ) as Partial<T>;
}
